const $ = require('jquery');
const throttle = require('lodash.throttle');
const changeWidth = 1000;
const $title = $('.sidebar__title');
const $content = $('.sidebar__title + div, .sidebar nav');
let lastSize = null;

if ($('.sidebar').length) {
  initSidebar();
}

window.addEventListener('resize', checkSidebar, {
  passive: true,
});

function initSidebar() {
  const thisWidth = window.innerWidth;
  if (thisWidth < changeWidth) {
    $content.hide();
  }
  lastSize = thisWidth;
}

function checkSidebar() {
  const thisWidth = window.innerWidth;
  if (lastSize >= changeWidth && thisWidth < changeWidth) {
    $content.hide();
  }
  lastSize = thisWidth;
}

$title.click(() => {
  if (window.innerWidth < changeWidth) {
    $content.slideToggle();
    $title.toggleClass('open');
  }
});
